// extracted by mini-css-extract-plugin
export default {"table":"gc4a4","scope":"pxkeu"};